import { useDispatch, useSelector } from 'react-redux';
import '../css/app.css'
import '../css/common.css'
import '../css/payment.css'
import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { change_Current_Location, changeHeaderTitle } from '../../store';
import axios from 'axios';
import { MessageModal } from '../component/modal/modal';
import bank from '../bankList'

import { CountAmount, CountAmountLeft, CountSelect, DownloadBtn, TotalAmount } from '../component/btn/btn';
import List from '../component/list/list';
import { LoadingModal } from '../component/modal/modal';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import { SquareX, SquareCheck } from 'lucide-react';

import Litepicker from 'litepicker';
import 'litepicker/dist/css/litepicker.css';
import { SearchDate, SearchRange, SearchSelect, SearchSelectText, SearchBtn, SearchCrteateBtn, SearchExcelBtn, SearchInputBtn } from '../component/search/search';
import { useLocation, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import dayjs from 'dayjs';

import { changeNum, convertDateFormat } from '../common/function';

const formatCardNumber = (cardNumber = "") => {
    const numericVal = cardNumber.replace(/\D/g, "");
    const parted = numericVal.match(/.{1,4}/g) || [];
    return parted.join("-");
};

function RiskBlackListManage() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const MyData = useSelector((state) => state.MyData);

    const [page, setPage] = useState(1);
    const [maxFirstPage, setMaxFirstPage] = useState(20);
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");
    const [listData, setListData] = useState([]);

    // 등록용 폼 데이터
    const initialFormData = { 카드번호: "" };
    const [formData, setFormData] = useState(initialFormData);
    // 왼쪽 리스트 중 어떤 행이 선택되었는지 저장
    const [clickData, setClickData] = useState(null);

    // 오른쪽 거래내역 리스트
    const [blackListData, setBlackListData] = useState([]);

    // 카드사(은행) 정보, "확인 불가" 등
    const [bank, setBank] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    // 왼쪽 테이블 합친 데이터
    const [combineData, setCombineData] = useState([]);
    // 오른쪽 테이블 합친 데이터
    const [blackCombineData, setBlackCombineData] = useState([]);

    const [reload, setReload] = useState(false);
    const [listState, setListState] = useState(false);

    const inputRef = useRef(null);
    const pickerRef = useRef(null);

    const [preDate, setPreDate] = useState(dayjs().format("YYYY-MM-DD"));
    const [nextDate, setNextDate] = useState(dayjs().format("YYYY-MM-DD"));

    // 1) 1초마다 현재 시간 갱신 (등록행에서 실시간으로 시간 표시)
    const [now, setNow] = useState(dayjs());
    useEffect(() => {
        const interval = setInterval(() => {
            setNow(dayjs());
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        dispatch(change_Current_Location("블랙리스트카드"));
        dispatch(
            changeHeaderTitle({
                mainTitle: "블랙리스트카드",
            })
        );
        setTimeout(() => {
            setLoading(false);
        }, 500);
    }, [dispatch]);

    // 날짜 선택
    useEffect(() => {
        pickerRef.current = new Litepicker({
            element: inputRef.current,
            lang: "ko",
            singleMode: false,
            format: "YYYY-MM-DD",
            numberOfMonths: 2,
            numberOfColumns: 2,
            showWeekNumbers: true,
            dropdowns: {
                minYear: 2020,
                maxYear: 2030,
                months: true,
                years: true,
            },
            setup: (picker) => {
                picker.on("selected", (start, end) => {
                    setPreDate(start.format("YYYY-MM-DD"));
                    setNextDate(end.format("YYYY-MM-DD"));
                });
            },
        });
        return () => {
            pickerRef.current?.destroy();
        };
    }, []);

    useEffect(() => {
        setDateRange(dayjs().format("YYYY-MM-DD"), dayjs().format("YYYY-MM-DD"));
    }, []);

    const setDateRange = (startDate, endDate) => {
        setPreDate(startDate);
        setNextDate(endDate);
        pickerRef.current?.setDateRange(startDate, endDate);
        onSubmitSearch();
    };

    const onSubmitSearch = () => {
        setPage(1);
        setReload((e) => !e);
    };

    useEffect(() => {
        ListData();
    }, [reload, page]);

    const ListData = async () => {
        try {
            const response = await axios.get(
                process.env.REACT_APP_API + "/api/card-blacklist",
                {
                    withCredentials: true,
                }
            );
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setListData(tmp?.data ?? []);
                setListState((e) => !e);
            } else if (tmp?.code === 9999) {
                navigate("/");
            }
        } catch (error) {
            console.error(error);
            navigate("/");
        }
    };

    // ---------------------------
    // 거래내역 가져오기
    // ---------------------------
    const BlackListData = async (cardNumber) => {
        try {
            const response = await axios.get(
                process.env.REACT_APP_API + "/api/card-blacklist/transactions",
                {
                    params: {
                        card_number: cardNumber,
                    },
                    withCredentials: true,
                }
            );
            let tmp = response?.data;
            console.log(tmp)
            if (tmp?.code < 2000) {
                setBlackListData(tmp?.data ?? []);
                setListState((e) => !e);
            } else if (tmp?.code === 9999) {
                navigate("/");
            }
        } catch (error) {
            console.error(error);
            navigate("/");
        }
    };

    const tableHeaderData = [
        { no: 1, text: "등록시간", width: "130px", textAlign: "center" },
        { no: 2, text: "카드번호", width: "170px", textAlign: "center" },
        { no: 3, text: "카드", width: "80px", textAlign: "center" },
        { no: 4, text: "버튼", width: "70px", textAlign: "center" },
    ];

    const tableHeaderData1 = [
        { no: 1, text: "거래시간", width: "130px", textAlign: "center" },
        { no: 2, text: "가맹점", width: "170px", textAlign: "center" },
        { no: 3, text: "금액", width: "80px", textAlign: "center" },
        { no: 4, text: "승인번호", width: "120px", textAlign: "center" },
    ];

    // 카드번호 입력 핸들러 (4-4-4-4)
    const handleCardNumberChange = (e) => {
        let inputVal = e.target.value;
        // 숫자만 추출
        let numericVal = inputVal.replace(/\D/g, "");
        // 최대 16자리
        numericVal = numericVal.slice(0, 16);
        // 4글자씩 끊어서 표시
        const parted = numericVal.match(/.{1,4}/g) ?? [];
        const displayVal = parted.join("-");

        setFormData((prev) => ({
            ...prev,
            카드번호: displayVal,
        }));

        // 8자리 이상이면 카드사 조회
        if (numericVal.length >= 8) {
            CheckBank(numericVal.slice(0, 8));
        } else {
            setBank("");
        }
    };

    // 카드사 조회
    const CheckBank = async (eightDigits) => {
        try {
            const response = await axios.get(
                process.env.REACT_APP_API + "/api/card-info/check",
                {
                    withCredentials: true,
                    params: { cardNumber: eightDigits },
                }
            );
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setBank(tmp?.data[0]?.card ?? "");
            } else if (tmp?.code === 9999) {
                navigate("/");
            } else {
                // 확인 불가 시 붉은색 표시
                setBank("확인 불가");
            }
        } catch (error) {
            console.error(error);
            setBank("확인 불가");
        }
    };

    // 블랙리스트카드 등록
    const onSubmit = async () => {
        if (isSubmitting) return;
        setIsSubmitting(true);

        try {
            await axios
                .post(
                    process.env.REACT_APP_API + "/api/card-blacklist",
                    {
                        // 등록 시 하이픈 제거한 값으로 전송
                        cardNumber: formData.카드번호.replace(/-/g, ""),
                    },
                    {
                        withCredentials: true,
                    }
                )
                .then((response) => {
                    let tmp = response?.data;
                    if (tmp?.code < 2000) {
                        setMessage({ msg: "블랙리스트카드 등록 성공했습니다." });
                        setReload((e) => !e);
                        // 등록 후 입력창 초기화
                        setFormData(initialFormData);
                        setBank("");
                    } else {
                        setMessage({
                            msg: tmp?.msg ?? "블랙리스트카드 등록에 실패했습니다.",
                        });
                    }
                })
                .catch((error) => {
                    setMessage({ msg: "블랙리스트카드 등록에 실패했습니다." });
                    console.error(error);
                });
        } finally {
            setIsSubmitting(false);
        }
    };

    // 블랙리스트카드 삭제
    const onDeleteData = async (id) => {
        if (!window.confirm("블랙리스트카드 목록을 삭제하시겠습니까?")) return;
        try {
            const response = await axios.post(
                process.env.REACT_APP_API + "/api/card-blacklist/delete",
                { id },
                { withCredentials: true }
            );
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setReload((e) => !e);
                // 혹시 삭제된 행이 현재 클릭된(선택된) 행이었다면 해제
                if (clickData && clickData.id === id) {
                    setClickData(null);
                    setBlackListData([]);
                }
            } else {
                setMessage({ msg: "블랙리스트카드 삭제 실패" });
            }
        } catch (error) {
            console.error(error);
        }
    };

    // 카드번호를 4-4-4-4 형태로 포맷
    const formatCardNumber = (cardNum = "") => {
        const numericVal = cardNum.replace(/\D/g, "").slice(0, 16);
        const parted = numericVal.match(/.{1,4}/g) ?? [];
        return parted.join("-");
    };

    // 왼쪽 리스트에서 행 클릭 시 처리 (등록행 제외)
    const handleLeftListRowClick = (rowArr) => {
        // rowArr.id가 없으면(= 첫번째 행), 거래내역을 불러오지 않음
        if (!rowArr?.id) return;

        // rowArr[1].text 가 카드번호(4-4-4-4 형태)
        const cardNumber = rowArr[1]?.text?.replace(/-/g, "");
        if (!cardNumber) return;

        // 선택된 행 상태 업데이트 (회색 강조)
        setClickData(rowArr);
        // 해당 카드번호로 거래내역 호출
        BlackListData(cardNumber);
    };

    // -------------------------------------------------
    // 테이블 BodyData 세팅(왼쪽)
    // -------------------------------------------------
    useEffect(() => {
        let tableBodyData = [];
        let list = listData ?? [];

        // 1) 첫 번째 행: 등록용
        tableBodyData.push([
            {
                no: 1,
                text: now.format("YYYY-MM-DD HH:mm:ss"),
                width: "130px",
                textAlign: "center",
            },
            {
                no: 2,
                text: (
                    <input
                        type="text"
                        value={formData.카드번호}
                        onChange={handleCardNumberChange}
                        style={{
                            padding: '0 10px',
                            fontSize: '12px',
                            width: 'calc(100% - 10px)',
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            textAlign: "center",
                            border: "1px solid rgb(13 148 136/1)"
                        }}
                    />
                ),
                width: "170px",
                textAlign: "center",
            },
            {
                no: 3,
                text:
                    bank === "확인 불가" ? (
                        <span style={{ color: "red" }}>{bank}</span>
                    ) : (
                        bank
                    ),
                width: "80px",
                textAlign: "center",
            },
            {
                no: 4,
                text: (
                    <div
                        className="flex justify-center items-center"
                        style={{ gap: "15px" }}
                    >
                        <a
                            className="delete flex items-center text-success pointer"
                            onClick={onSubmit}
                        >
                            <SquareCheck width={15} height={15} /> 등록
                        </a>
                    </div>
                ),
                width: "70px",
                textAlign: "center",
            },
        ]);

        // 2) 두 번째 줄부터: 실제 블랙리스트 목록
        for (let i = 0; i < list.length; i++) {
            let data = list[i];
            let formattedCardNumber = formatCardNumber(data.cardNumber || "");

            let rowData = [
                {
                    no: 1,
                    text: data.createdAt,
                    width: "130px",
                    textAlign: "center",
                },
                {
                    no: 2,
                    text: formattedCardNumber,
                    width: "170px",
                    textAlign: "center",
                },
                {
                    no: 3,
                    text: data.cardIssuer,
                    width: "80px",
                    textAlign: "center",
                },
                {
                    no: 4,
                    text: (
                        <div
                            className="flex justify-center items-center"
                            style={{ gap: "15px" }}
                        >
                            <a
                                className="delete flex items-center text-danger pointer"
                                onClick={(e) => {
                                    e.stopPropagation(); // 삭제 클릭 시 행 클릭 이벤트 막기
                                    onDeleteData(data.id);
                                }}
                            >
                                <SquareX width={15} height={15} /> 삭제
                            </a>
                        </div>
                    ),
                    width: "70px",
                    textAlign: "center",
                },
            ];
            // ※ rowArr에 id를 저장해두어야 클릭/선택 구분 가능
            rowData.id = data.id;

            tableBodyData.push(rowData);
        }

        setCombineData(tableBodyData);
        setListState((e) => !e);
    }, [listData, formData, bank, now]);

    // -------------------------------------------------
    // 테이블 BodyData 세팅(오른쪽: 거래내역)
    // -------------------------------------------------
    useEffect(() => {
        let tableBodyData = [];
        let list = blackListData ?? [];

        for (let i = 0; i < list.length; i++) {
            let data = list[i];

            let rowData = [
                {
                    no: 1,
                    text: data.trx_date,
                    width: "130px",
                    textAlign: "center",
                },
                {
                    no: 2,
                    text: data.co_nm,
                    width: "170px",
                    textAlign: "left",
                },
                {
                    no: 3,
                    text: changeNum(data.amt),
                    width: "80px",
                    textAlign: "right",
                },
                {
                    no: 4,
                    text: data.trx_id,
                    width: "120px",
                    textAlign: "center",
                },
            ];
            rowData.id = data.id;

            tableBodyData.push(rowData);
        }

        setBlackCombineData(tableBodyData);
        setListState((e) => !e);
    }, [blackListData]);

    return (
        <div className="content" id="contents">
            {loading ? <LoadingModal /> : null}
            <MessageModal message={message} />

            <div className="form_filter intro-y">
                <form id="tabulator-html-filter-form">
                    <SearchDate
                        type={"기간"}
                        inputRef={inputRef}
                        setDateRange={setDateRange}
                        preDate={preDate}
                        nextDate={nextDate}
                        isDisabled={true}
                    />
                </form>
            </div>

            <div
                className="intro-y box intro-padding"
            >
                <div className="div-flex-2 contents">
                    {/* 왼쪽 리스트 */}
                    <div style={{ width: "100%", maxWidth: "450px" }}>
                        <List
                            tableHeaderData={tableHeaderData}
                            tableBodyData={combineData}
                            filter_tableBodyData={combineData}
                            page={page}
                            setPage={setPage}
                            maxFirstPage={maxFirstPage}
                            listType={true}
                            listState={listState}
                            // 추가: 클릭 핸들러/선택 정보
                            onRowClick={handleLeftListRowClick}
                            clickData={clickData}
                        />
                    </div>

                    {clickData && (
                        <div
                            style={{
                                width: "100%",
                                marginTop: "0.75rem",
                                maxWidth: "570px",
                            }}
                        >
                            <div
                                style={{
                                    backgroundColor: "#575757",
                                    padding: "16px",
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        gap: "10px",
                                        alignItems: "center",
                                        padding: "0 10px",
                                        borderBottom: "1px solid #E5E5E5",
                                        backgroundColor: "#fff",
                                    }}
                                >
                                    {["거래내역"].map((tab) => (
                                        <button
                                            key={tab}
                                            className="tab-btn active"
                                            style={{
                                                padding: "12px 10px 8px",
                                                fontSize: "14px",
                                                fontWeight: "600",
                                                color: "#222",
                                                background: "transparent",
                                                border: "none",
                                                borderBottom: "3px solid #3182F6",
                                                transition: "all 0.2s ease-in-out",
                                                cursor: "pointer",
                                            }}
                                        >
                                            {tab}
                                        </button>
                                    ))}
                                </div>
                                <div style={{ padding: "0 10px", backgroundColor: "#fff" }}>
                                    <List
                                        tableHeaderData={tableHeaderData1}
                                        tableBodyData={blackCombineData}
                                        filter_tableBodyData={blackCombineData}
                                        listType={true}
                                        listState={listState}
                                        height={"600px"}
                                        nonePage={false}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default RiskBlackListManage